import React from 'react';
/* ──────────────────────────────────────────────────────────────────────────
   خروجی اکسل یک‌دست برای همهٔ گریدهای برنامه؛ ورودی همان ستون‌ها و ردیف‌های گرید است.

   بدون وابستگی npm:
     * .xls به‌صورت جدول HTML با UTF-8 و راست‌به‌چپ — اکسل مستقیم بازش می‌کند.
     * .csv برای ابزارهای دیگر (با BOM تا اکسل فارسی را درست بخواند).

   استفاده:
     import { exportGrid } from '../../components/excel';

     exportGrid({
       title: 'اسناد هزینه درحال رسیدگی',
       columns: [
         { key: 'document_no', label: 'سندهزینه', num: true },
         { key: 'remark',      label: 'شرح' },
       ],
       rows: data,
     });
   ────────────────────────────────────────────────────────────────────────── */

const esc = (v) => String(v ?? '')
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;');

/** نام فایل امن — کاراکترهای غیرمجاز در نام فایل حذف می‌شوند. */
function safeName(title, ext) {
  const t = String(title || 'گزارش').replace(/[\\/:*?"<>|]/g, '-').trim();
  return `${t}.${ext}`;
}

function download(blob, filename) {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}

/**
 * خروجی اکسل (.xls) از ستون‌ها و ردیف‌های یک گرید.
 *
 * columns: [{ key, label, num? }]  — num=true یعنی ستون عددی (راست‌چین، بدون جداکننده)
 * rows:    آرایهٔ آبجکت‌ها
 * title:   عنوان گزارش (هم تیتر بالای فایل، هم نام فایل)
 * subtitle: خط توضیح اختیاری زیر عنوان (مثلاً بازهٔ تاریخ)
 */
export function exportGrid({ title, subtitle, columns, rows }) {
  const cols = (columns || []).filter(Boolean);
  const list = rows || [];

  const head = cols.map(c =>
    `<th style="background:#1a2f50;color:#fff;border:1px solid #888;padding:6px;`
    + `font-weight:bold;white-space:nowrap">${esc(c.label)}</th>`).join('');

  const body = list.map(r => '<tr>' + cols.map(c => {
    const v = r[c.key];
    if (c.num) {
      const n = Number(v);
      return `<td style="border:1px solid #bbb;padding:4px;`
           + `mso-number-format:'\\#\\,\\#\\#0'">${Number.isFinite(n) ? n : ''}</td>`;
    }
    // چندخطی را در سلول اکسل حفظ می‌کنیم
    const txt = esc(v).replace(/\n/g, '<br/>');
    return `<td style="border:1px solid #bbb;padding:4px;mso-number-format:'\\@'">${txt}</td>`;
  }).join('') + '</tr>').join('');

  const html =
`<html xmlns:x="urn:schemas-microsoft-com:office:excel">
<head><meta charset="UTF-8">
<!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>
<x:Name>${esc(String(title || 'گزارش').slice(0, 30))}</x:Name>
<x:WorksheetOptions><x:DisplayRightToLeft/></x:WorksheetOptions>
</x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
<style>table{border-collapse:collapse;font-family:Tahoma;font-size:11pt}</style>
</head>
<body dir="rtl">
<h3 style="font-family:Tahoma">${esc(title || '')}</h3>
${subtitle ? `<div style="font-family:Tahoma;font-size:10pt">${esc(subtitle)}</div>` : ''}
<table dir="rtl"><thead><tr>${head}</tr></thead><tbody>${body}</tbody></table>
</body></html>`;

  download(new Blob(['\uFEFF' + html], { type: 'application/vnd.ms-excel;charset=utf-8' }),
           safeName(title, 'xls'));
}

/** همان داده‌ها در قالب CSV — برای ابزارهایی غیر از اکسل. */
export function exportCsv({ title, columns, rows }) {
  const cols = (columns || []).filter(Boolean);
  const q = v => `"${String(v ?? '').replace(/"/g, '""').replace(/\n/g, ' / ')}"`;
  const lines = [cols.map(c => q(c.label)).join(',')];
  (rows || []).forEach(r => lines.push(cols.map(c => q(r[c.key])).join(',')));
  download(new Blob(['\uFEFF' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8;' }),
           safeName(title, 'csv'));
}

/**
 * دکمهٔ آمادهٔ «خروجی اکسل».
 * اگر ردیفی نباشد، دکمه نمایش داده نمی‌شود.
 */
export function ExcelButton({ title, subtitle, columns, rows, style, label = '⬇ اکسل' }) {
  if (!rows || rows.length === 0) return null;
  return (
    <button
      type="button"
      onClick={() => exportGrid({ title, subtitle, columns, rows })}
      title={`خروجی اکسل — ${title || ''}`}
      style={{
        padding: '5px 10px', background: '#1d6f42', color: '#fff', border: 'none',
        borderRadius: '6px', fontFamily: 'inherit', fontSize: '12px', fontWeight: 700,
        cursor: 'pointer', whiteSpace: 'nowrap', ...(style || {}),
      }}
    >{label}</button>
  );
}
